// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay[data-v-15f88ba4]{background:url(/images/solutions/overlay.png) 50% no-repeat;background-size:cover}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
